import Vue from "vue";
import VueI18n from "vue-i18n";
import Cookies from "js-cookie";
import elementEnLocale from "element-ui/lib/locale/lang/en"; // element-ui 英文
import elementZhLocale from "element-ui/lib/locale/lang/zh-CN"; // element-ui 简体中文
import elementzhHKLocale from "element-ui/lib/locale/lang/zh-TW"; // element-ui 中文繁体版
import enLocale from "./lang/en";
import zhLocale from "./lang/zh-cn";
import zhHKLocale from "./lang/zh-hk";

Vue.use(VueI18n);

const messages = {
  "zh-cn": {
    ...zhLocale,
    ...elementZhLocale,
  },
  "zh-hk": {
    ...zhHKLocale,
    ...elementzhHKLocale,
  },
  "en-us": {
    ...enLocale,
    ...elementEnLocale,
  },
};
export function getLanguage() {
  const chooseLanguage = localStorage.getItem("lang");
  if (chooseLanguage) {
    return chooseLanguage;
  } else {
    console.log("Failed to get current language");
  }
  // if (chooseLanguage) return chooseLanguage

  // // if has not choose language
  // const language = (navigator.language || navigator.browserLanguage).toLowerCase()
  // const locales = Object.keys(messages)
  // for (const locale of locales) {
  //   if (language.indexOf(locale) > -1) {
  //     return locale
  //   }
  // }
  //特做需求  以前默认是 zh-cn
}
const i18n = new VueI18n({
  // set locale
  // options: en | zh | es
  locale: getLanguage(),
  // set locale messages
  messages,
});

export default i18n;
